import { BulletedListButtons } from './BulletListDropdown'
import { NumberedListButtons } from './NumberedListDropdown'
import { VoteListButton } from './VoteListButton'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { SimpleDropdownItem } from '../SimpleDropdown/SimpleDropdownItem'
import Styles from '../SingleMenuDropdown/SingleMenuDropdown.module.scss'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'
import { CheckListItem } from 'common/Prose/Toolbar/ToolbarBravo/ListsGroup/CheckListItem'
import { ToggleBlockItem } from 'common/Prose/Toolbar/ToolbarBravo/ListsGroup/ToggleBlockItem'

export const ListsDropdown = () => {
  return (
    <SimpleDropdown tooltip={{ label: 'Lists' }} bodyClassName={Styles.dropdownBody}>
      <ToolbarIcon name={IconName.List} />
      <>
        <SimpleDropdown aria-label="Lists" placement="right-start" isSubmenu>
          <SimpleDropdownItem icon={<ToolbarIcon name={IconName.List} />} label="Bulleted List" withChevron />
          <BulletedListButtons />
        </SimpleDropdown>
        <SimpleDropdown aria-label="Lists" placement="right-start" isSubmenu>
          <SimpleDropdownItem icon={<ToolbarIcon name={IconName.ListNumbers} />} label="Numbered List" withChevron />
          <NumberedListButtons />
        </SimpleDropdown>
        <CheckListItem withLabel />
        <ToggleBlockItem withLabel />
        <VoteListButton withLabel />
      </>
    </SimpleDropdown>
  )
}
